import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useModalStore } from "@/stores/use-modal-store";
import { cn } from "@/lib/utils";
import { AlertDialogWrapper } from "./alert-dialog-wrapper";

export function GlobalModal() {
  const { modals, closeModal } = useModalStore();
  const modal = modals[modals.length - 1];

  if (!modal) return null;

  const { component: Component, props, id, options } = modal;

  const sizeMap = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-3xl",
    full: "w-full h-full",
  };

  const variantClass = {
    default: "rounded-lg",
    fullscreen: "w-screen h-screen max-w-none rounded-none p-6",
    slide:
      "fixed right-0 top-0 h-screen w-[400px] max-w-full rounded-none border-l bg-background shadow-lg animate-in slide-in-from-right",
  };

  // 🟡 AlertDialog 렌더링 분기
  if (options?.variant === "alert") {
    return <AlertDialogWrapper {...props} close={closeModal} />;
  }

  return (
    <Dialog open onOpenChange={() => closeModal({ action: "cancel" })}>
      <DialogContent
        key={id}
        className={cn(
          "w-full",
          sizeMap[options?.size ?? "md"],
          variantClass[options?.variant ?? "default"]
        )}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <Component {...props} close={closeModal} />
      </DialogContent>
    </Dialog>
  );
}
